import { Flex } from 'components'
import { DataType } from 'ka-table'
import { startCase } from 'lodash-es'
import { ReactNode } from 'react'
import { useTheme } from 'utils'
import { InputContainerProps, Text, TextProps } from '.'
import InputContainer from './InputContainer'

export interface Props extends Omit<InputContainerProps, 'children'> {
  label?: string
  value?: any | ReactNode
  dataType?: DataType
  textProps?: TextProps
}

export default function ReadOnlyProperty({ label, value, dataType, textProps, ...rest }: Props) {
  const { theme: colorMode } = useTheme()
  if (value == null) return null

  return (
    <InputContainer gap={1} label={startCase(label)} {...rest}>
      {typeof value === 'string' ? (
        <Text
          textStyle="bodySmall"
          fontWeight="normal"
          background={colorMode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.1)'}
          borderRadius="10px"
          p={2}
          {...textProps}
        >
          {dataType ? formatDatatype(value, dataType) : value}
        </Text>
      ) : (
        <Flex
          background={colorMode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.1)'}
          borderRadius="10px"
          p={2}
        >
          {value}
        </Flex>
      )}
    </InputContainer>
  )
}

function formatDatatype(value: string, dataType: DataType) {
  switch (dataType) {
    case DataType.Date:
      return new Date(value).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      })
    case DataType.Boolean:
      return value === 'true' ? 'Yes' : 'No'
    case DataType.Number:
      return value.toLocaleString()
    default:
      return value.toString()
  }
}
